module.exports = __webpack_public_path__ + "media/paliwa/hybrid@3x-7192c54f.svg";